import { render, staticRenderFns } from "./modal-mixin.vue?vue&type=template&id=b5f19fa6"
import script from "./modal-mixin.vue?vue&type=script&lang=js"
export * from "./modal-mixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports